import { useMemo } from "react";
import { COLUMN_COLORS, COLUMN_INK, columnFor, fisherYates } from "./logic";
import { useHallStore } from "./store";

export function MixFallback({ count = 12 }: { count?: number }) {
  const remaining = useHallStore((s) => s.remaining);
  const current = useHallStore((s) => s.current);
  const balls = useMemo(() => {
    const pool = remaining.slice();
    if (current != null && !pool.includes(current)) pool.push(current);
    return fisherYates(pool).slice(0, count);
  }, [remaining, current, count]);

  return (
    <div className="v2-mix-fallback v2-keep-motion" aria-hidden>
      <div className="v2-mix-cage">
        {balls.map((num, i) => {
          const col = columnFor(num);
          const angle = (i / Math.max(1, balls.length)) * Math.PI * 2 + 0.4;
          const radius = 26 + (i % 4) * 7;
          return (
            <span
              key={num}
              className="v2-mix-ball"
              style={{
                backgroundColor: col === "N" ? "#f7f3ea" : COLUMN_COLORS[col],
                color: COLUMN_INK[col],
                animationDelay: `${(i % 8) * -0.12}s`,
                ["--x" as string]: `${Math.cos(angle) * radius}%`,
                ["--y" as string]: `${Math.sin(angle) * radius}%`,
              }}
            >
              <small>{col}</small>
              {num}
            </span>
          );
        })}
      </div>
    </div>
  );
}
